import React from 'react';
import SectionHeader from '@apricityhealth/web-common-lib/components/headers/SectionHeader';

import DelegateIcon from '@material-ui/icons/Person';

export default ({title, subtitle, color}) => {
    return (
        <SectionHeader
            color={color}
            title={title}
            subtitle={subtitle}
            icon={<DelegateIcon style={{ color}}/>}
        />
    );
}

